import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";
import { groupBy } from 'lodash'

import { CustomTitleLabel } from "components/earning/CustomBaseComponments";

import "./GenerateCouponSection.scss"
import { COUPON_CODE_TYPE, COUPON_SET_MEDIUM, COUPON_SET_TYPES } from "config/CustomEnums";
import CustomFileUploader from "components/base/CustomFileUploader";
import { ImageButton } from "components/base/CustomImageButton";
import ArrowIcon from 'assets/images/tree_arrow_bottom.png';
import { getCouponSetMedium } from "containers/engagement/campaignStreamline/CreateCampaignCouponPageConfig";

const mapPropsToState = (state) => ({
});

const OneGroupedStoresSection = ({
  hideInputAndImport = false,
  groupLabel,
  stores,
  couponSetOnlineCouponCodeType,
  couponSetOfflineCouponCodeType,
  couponSetOfflineCouponSource,
  onRemoveUploadedFile = () => { },
  afterUploadFile = () => { },
  onInputStoreCouponNum = () => { },
  storeInputCouponNumMap,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(true)
  const shouldImportByFile = (isOnlineStore) => {
    if (isOnlineStore) {
      return couponSetOnlineCouponCodeType === COUPON_CODE_TYPE.UNIQUE
    }
    return couponSetOfflineCouponSource === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON
      && couponSetOfflineCouponCodeType === COUPON_CODE_TYPE.UNIQUE
  }
  return <>
    <div className={"one-group-header"} onClick={() => setIsOpen(prev => !prev)}>
      <div className="one-group-header-title">
        <ImageButton
          image={ArrowIcon}
          className={isOpen ? 'expand' : 'shrink'}
          action={() => { }}
        />
        <CustomTitleLabel title={groupLabel} />
      </div>
    </div>
    {isOpen ? <ul className="one-group-content">
      {
        stores?.map(item => (
          <li className="one-group-item">
            <div>{item?.name || ''}</div>
            {!hideInputAndImport ?
              shouldImportByFile(item?.isOnlineStore) ?
                <div>
                  <CustomFileUploader
                    title="Select files"
                    accept=".csv"
                    showFileName={true}
                    removeUploadedFileAction={() => {
                      onRemoveUploadedFile(item?.pk || item?.id)
                    }}
                    afterUploadAction={(uploadedFile) => {
                      const filePath = uploadedFile?.import
                      afterUploadFile(item?.pk || item?.id, filePath)
                    }}
                    disabled={disabled}
                  />
                </div>
                : <input
                  className="day-input-fields"
                  type="number"
                  onChange={(e) => {
                    const { value } = e.target;
                    onInputStoreCouponNum(item?.pk || item?.id, value > 100000 ? 100000 : value)
                  }}
                  value={storeInputCouponNumMap?.[item?.pk || item?.id] || ""}
                  min={1}
                  max={100000}
                  disabled={disabled}
                />
              : null
            }
          </li>
        ))
      }
    </ul> : null}
  </>
}

const AllOnlineOrOfflineCouponGenerateSection = ({
  title,
  groupItems,
  groupLabel,
  isImport = false,
  inputValue,
  onChangInputValue,
  onUploadFile,
  onRemoveUploadedFile,
  disabled,
}) => {
  return (
    <div className="one-group">
      <div className="one-group-item">
        <div className="generate-all-store-title">{title || ''}</div>
        {
          isImport ?
            <div>
              <CustomFileUploader
                title="Select files"
                accept=".csv"
                showFileName={true}
                removeUploadedFileAction={() => {
                  onRemoveUploadedFile()
                }}
                afterUploadAction={(uploadedFile) => {
                  const filePath = uploadedFile?.import
                  onUploadFile(filePath)
                }}
                disabled={disabled}
              />
            </div>
            : <input
              className="day-input-fields"
              type="number"
              onChange={(e) => {
                const { value } = e.target;
                onChangInputValue(value > 100000 ? 100000 : value)
              }}
              value={inputValue || ""}
              min={1}
              max={100000}
              disabled={disabled}
            />
        }
      </div>
      <OneGroupedStoresSection
        hideInputAndImport={true}
        groupLabel={groupLabel}
        stores={groupItems}
        disabled={disabled}
      />
    </div>
  )
}


// grouped by brand
const GenerateCouponSection = ({
  title,
  description,
  stores,
  customGetGroupedStores,
  shouldBeUsedInStores,
  couponSetOnlineCouponCodeType,
  couponSetOfflineCouponCodeType,
  couponSetOfflineCouponSource,
  couponSetMedium,  // type: COUPON_SET_MEDIUM,
  groupKey = "brandName",
  setCouponCodeSeparately = false,
  allOnlineOfflineStoreCouponConfig = {
    inputValue: "",
    onChangInputValue: () => { },
    onUploadFile: () => { },
    onRemoveUploadedFile: () => { },
  },
  allOnlineStoreCouponConfig = {
    inputValue: "",
    onChangInputValue: () => { },
    onUploadFile: () => { },
    onRemoveUploadedFile: () => { },
  },
  allOfflineStoreCouponConfig = {
    inputValue: "",
    onChangInputValue: () => { },
    onUploadFile: () => { },
    onRemoveUploadedFile: () => { },
  },
  oneStoreCouponConfig = {
    onInputStoreCouponNum: () => { },
    onRemoveUploadedFile: () => { },
    afterUploadFile: () => { },
    storeInputCouponNumMap: {},
  },
  disabled
}) => {
  const generateOnlineAndOffline = !shouldBeUsedInStores
    && couponSetMedium === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
    && !setCouponCodeSeparately
  const generateAllOnlineCoupon = !generateOnlineAndOffline && !shouldBeUsedInStores && [
    COUPON_SET_MEDIUM.ONLINE,
    COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE,
  ].includes(couponSetMedium);
  const generateAllOfflineCoupon = !generateOnlineAndOffline && !shouldBeUsedInStores && [
    COUPON_SET_MEDIUM.OFFLINE,
    COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE,
  ].includes(couponSetMedium);
  const generateAllOnlineCouponByFile = couponSetOnlineCouponCodeType === COUPON_CODE_TYPE.UNIQUE;
  const generateAllOfflineCouponByFile = couponSetOfflineCouponSource === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON
    && couponSetOfflineCouponCodeType === COUPON_CODE_TYPE.UNIQUE;

  const allStoreRelatedBrands = useMemo(() => {
    if (!generateOnlineAndOffline) {
      return []
    }
    const allBrandsList = stores?.filter(store => !!store?.brandId)?.map(store => store?.brandName)
    const cleanedBrandsList = [...new Set(allBrandsList)]
    return cleanedBrandsList?.reduce((res, value) => {
      res.push({ name: value })
      return res
    }, []);
  }, [generateOnlineAndOffline, stores])

  const onlineStoreRelatedBrands = useMemo(() => {
    if (!generateAllOnlineCoupon) {
      return []
    }
    const allBrandsList = stores?.filter(store => store?.isOnlineStore && !!store?.brandId)?.map(store => store?.brandName)
    const cleanedBrandsList = [...new Set(allBrandsList)]
    return cleanedBrandsList?.reduce((res, value) => {
      res.push({ name: value })
      return res
    }, []);
  }, [generateAllOnlineCoupon, stores])

  const offlineStoreRelatedBrands = useMemo(() => {
    if (!generateAllOfflineCoupon) {
      return []
    }
    const allBrandsList = stores?.filter(store => !store?.isOnlineStore && !!store?.brandId)?.map(store => store?.brandName)
    const cleanedBrandsList = [...new Set(allBrandsList)]
    return cleanedBrandsList?.reduce((res, value) => {
      res.push({ name: value })
      return res
    }, []);
  }, [generateAllOfflineCoupon, stores])

  const groupedStores = customGetGroupedStores ? customGetGroupedStores(stores) : groupBy(stores, groupKey);
  return <div>
    {title && <CustomTitleLabel title={title} />}
    {description && <div className="tips-message">{description}</div>}
    <div className="generate-coupon-container">
      {
        generateOnlineAndOffline &&
        <AllOnlineOrOfflineCouponGenerateSection
          title={"All stores"}
          groupItems={allStoreRelatedBrands}
          groupLabel={"Store related brand reference"}
          isImport={generateAllOnlineCouponByFile}
          inputValue={allOnlineOfflineStoreCouponConfig?.inputValue}
          onChangInputValue={allOnlineOfflineStoreCouponConfig?.onChangInputValue}
          onUploadFile={allOnlineOfflineStoreCouponConfig?.onUploadFile}
          onRemoveUploadedFile={allOnlineOfflineStoreCouponConfig?.onRemoveUploadedFile}
          disabled={disabled}
        />
      }
      {generateAllOnlineCoupon &&
        <AllOnlineOrOfflineCouponGenerateSection
          title={"All online stores"}
          groupItems={onlineStoreRelatedBrands}
          groupLabel={"Online store related brand reference"}
          isImport={generateAllOnlineCouponByFile}
          inputValue={allOnlineStoreCouponConfig?.inputValue}
          onChangInputValue={allOnlineStoreCouponConfig?.onChangInputValue}
          onUploadFile={allOnlineStoreCouponConfig?.onUploadFile}
          onRemoveUploadedFile={allOnlineStoreCouponConfig?.onRemoveUploadedFile}
          disabled={disabled}
      />
      }
      {generateAllOfflineCoupon &&
        <AllOnlineOrOfflineCouponGenerateSection
          title={"All offline stores"}
          groupItems={offlineStoreRelatedBrands}
          groupLabel={"Offline store related brand reference"}
          isImport={generateAllOfflineCouponByFile}
          inputValue={allOfflineStoreCouponConfig?.inputValue}
          onChangInputValue={allOfflineStoreCouponConfig?.onChangInputValue}
          onUploadFile={allOfflineStoreCouponConfig?.onUploadFile}
          onRemoveUploadedFile={allOfflineStoreCouponConfig?.onRemoveUploadedFile}
          disabled={disabled}
      />
      }
      {
        shouldBeUsedInStores && Object.entries(groupedStores)?.map(([groupLabel, storeList]) => (
          <div className="one-group">
            <OneGroupedStoresSection
              hideInputAndImport={!shouldBeUsedInStores}
              groupLabel={groupLabel}
              stores={storeList}
              couponSetOnlineCouponCodeType={couponSetOnlineCouponCodeType}
              couponSetOfflineCouponCodeType={couponSetOfflineCouponCodeType}
              couponSetOfflineCouponSource={couponSetOfflineCouponSource}
              onInputStoreCouponNum={oneStoreCouponConfig?.onInputStoreCouponNum}
              onRemoveUploadedFile={oneStoreCouponConfig?.onRemoveUploadedFile}
              afterUploadFile={oneStoreCouponConfig?.afterUploadFile}
              storeInputCouponNumMap={oneStoreCouponConfig?.storeInputCouponNumMap}
              disabled={disabled}
            />
          </div>
        ))
      }
    </div>
  </div>
}

export const CampaignStreamlineGenerateCouponSection = ({
  hideSectionHeader,
  title = "Applicable stores",
  couponSetFieldPrefix,
  disabled,
}) => {
  const { watch, setValue } = useFormContext();

  const couponStores = watch(`${couponSetFieldPrefix}selectedStores`);
  const shouldBeUsedInStores = watch(`${couponSetFieldPrefix}shouldBeUsedInStores`);
  const couponSetMedium = getCouponSetMedium(couponStores);
  const couponGenerateInfoPrefix = `${couponSetFieldPrefix}couponGenerateInfo.`

  // store coupon
  const couponImportFileField = `${couponGenerateInfoPrefix}storeImportFileMap`
  const couponInputFileField = `${couponGenerateInfoPrefix}inputStoreCoupon`
  const inputStoreCoupon = watch(couponInputFileField)
  const importFileMap = watch(couponImportFileField)

  // all online store coupon
  const allOnlineStoreCouponImportField = `${couponGenerateInfoPrefix}allOnlineStoreImportFile`;
  const allOnlineStoreCouponInputField = `${couponGenerateInfoPrefix}allOnlineStoreInput`;
  const allOnlineStoreCouponInput = watch(allOnlineStoreCouponInputField);
  // all offline store coupon
  const allOfflineStoreCouponImportField = `${couponGenerateInfoPrefix}allOfflineStoreImportFile`;
  const allOfflineStoreCouponInputField = `${couponGenerateInfoPrefix}allOfflineStoreInput`;
  const allOfflineStoreCouponInput = watch(allOfflineStoreCouponInputField);
  // online and offline
  const allOnlineOfflineImportField = `${couponGenerateInfoPrefix}allOnlineOfflineImport`;
  const allOnlineOfflineInputField = `${couponGenerateInfoPrefix}allOnlineOfflineInput`;
  const allOnlineOfflineStorCouponInput = watch(allOnlineOfflineInputField);

  let couponSetOnlineCouponCodeTypeField = `${couponSetFieldPrefix}onlineCouponCodeType`
  let couponSetOfflineCouponCodeTypeField = `${couponSetFieldPrefix}offlineCouponCodeType`
  let couponSetOfflineCouponSourceField = `${couponSetFieldPrefix}offlineCouponSetType`
  const setCouponCodeSeparately = watch(`${couponSetFieldPrefix}isDifferentCodeForOnlineOffline`)
  if (couponSetMedium === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE && !setCouponCodeSeparately) {
    couponSetOnlineCouponCodeTypeField = `${couponSetFieldPrefix}onlineAndOfflineCouponCodeType`
    couponSetOfflineCouponCodeTypeField = `${couponSetFieldPrefix}onlineAndOfflineCouponCodeType`
    couponSetOfflineCouponSourceField = `${couponSetFieldPrefix}onlineAndOfflineCouponSetType`
  }

  return <GenerateCouponSection
    title={hideSectionHeader ? "" : title}
    description={hideSectionHeader ? "" : shouldBeUsedInStores
      ? "Please upload the coupon codes (one store one .csv file)."
      : "Please input the number of coupons to be generated. You can set to max 100,000 if there is no specific limit."
    }
    couponSetMedium={couponSetMedium}
    stores={couponStores}
    shouldBeUsedInStores={shouldBeUsedInStores}
    setCouponCodeSeparately={setCouponCodeSeparately}
    couponSetOnlineCouponCodeType={watch(couponSetOnlineCouponCodeTypeField)}
    couponSetOfflineCouponCodeType={watch(couponSetOfflineCouponCodeTypeField)}
    couponSetOfflineCouponSource={watch(couponSetOfflineCouponSourceField)}
    groupKey='brandName'
    allOnlineOfflineStoreCouponConfig={{
      inputValue: allOnlineOfflineStorCouponInput,
      onChangInputValue: (value) => {
        setValue(allOnlineOfflineInputField, value, { shouldDirty: true });
      },
      onUploadFile: (filePath) => {
        setValue(allOnlineOfflineImportField, filePath, { shouldDirty: true });
      },
      onRemoveUploadedFile: () => {
        setValue(allOnlineOfflineImportField, null, { shouldDirty: true });
      },
    }}
    allOnlineStoreCouponConfig={{
      inputValue: allOnlineStoreCouponInput,
      onChangInputValue: (value) => {
        setValue(allOnlineStoreCouponInputField, value, { shouldDirty: true });
      },
      onUploadFile: (filePath) => {
        setValue(allOnlineStoreCouponImportField, filePath, { shouldDirty: true });
      },
      onRemoveUploadedFile: () => {
        setValue(allOnlineStoreCouponImportField, null, { shouldDirty: true });
      },
    }}
    allOfflineStoreCouponConfig={{
      inputValue: allOfflineStoreCouponInput,
      onChangInputValue: (value) => {
        setValue(allOfflineStoreCouponInputField, value, { shouldDirty: true });
      },
      onUploadFile: (filePath) => {
        setValue(allOfflineStoreCouponImportField, filePath, { shouldDirty: true });
      },
      onRemoveUploadedFile: () => {
        setValue(allOfflineStoreCouponImportField, null, { shouldDirty: true });
      },
    }}
    oneStoreCouponConfig={{
      onInputStoreCouponNum: (storeID, value) => {
        setValue(couponInputFileField, { ...inputStoreCoupon, [storeID]: value }, { shouldDirty: true });
      },
      onRemoveUploadedFile: (storeID) => {
        setValue(couponImportFileField, { ...importFileMap, [storeID]: null }, { shouldDirty: true });
      },
      afterUploadFile: (storeID, filePath) => {
        setValue(couponImportFileField, { ...importFileMap, [storeID]: filePath }, { shouldDirty: true });
      },
      storeInputCouponNumMap: inputStoreCoupon
    }}
    disabled={disabled}
  />
}


export default connect(mapPropsToState)(GenerateCouponSection);